<template>
	<router-view class="main"/>
</template>

<script>
	export default {
		name: 'Index'
	}
</script>

<style lang="scss">
	body {
		margin: 0;
	}

	a {
		text-decoration: none;
	}

	ul {
		list-style-type: none;
	}
</style>
